// extracted by mini-css-extract-plugin
export default {"heading":"home_heading__JyjX3","bgImg":"home_bgImg__Ckqou","SaveButton":"home_SaveButton__+kG79","closeIcon":"home_closeIcon__qRjhc"};